import {
  Box,
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";

const TableHeader = (props) => {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;

  const headCells = [
    {
      id: "utility_code",
      label: "Utility Code",
      enableSort: true,
    },
    {
      id: "utility_name",
      label: "Utility Name",
      enableSort: true,
    },
    {
      id: "state_id",
      label: "State",
      enableSort: true,
    },
    {
      id: "commodity",
      label: "Commodity",
      enableSort: false,
    },
    {
      id: "class",
      label: "Class",
      enableSort: false,
    },

    {
      id: "month",
      label: "Last PTC Update",
    },{
      id: "has_start_date",
      label: "Has Start Date"
    },{
      id: "has_end_date",
      label: "Has End Date"
    },
    {
      id: "original_price",
      label: "Exact Website Value"
    },
    {
      id: "ptc_rate",
      label: "PTC Rate(¢)",
    },
    {
      id: "uom",
      label: "UOM",
      enableSort: false,
    },
    {
      id: "last_updated",
      label: "Last Scanned Date",
    },
    {
      id: "source_url",
      label: "Source URL",
    },
    {
      id: "graduated_standard_rate",
      label: "Graduated Standard Rate"
    },
    // {
    //   id: "period",
    //   label: "Period"
    // },
  ];
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {/* {orderBy === headCell.id ? (
                <Box component="span">
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null} */}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
export default TableHeader;
